var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarDefaultBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9999 49.0153C58.5881 49.0153 62.3076 45.2958 62.3076 40.7076C62.3076 36.1194 58.5881 32.3999 53.9999 32.3999C49.4117 32.3999 45.6922 36.1194 45.6922 40.7076C45.6922 45.2958 49.4117 49.0153 53.9999 49.0153ZM59.3168 40.7076C59.3168 43.6441 56.9364 46.0245 53.9999 46.0245C51.0635 46.0245 48.683 43.6441 48.683 40.7076C48.683 37.7711 51.0635 35.3907 53.9999 35.3907C56.9364 35.3907 59.3168 37.7711 59.3168 40.7076Z",
    fill: "#00B956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4159 55.3266L42.3691 55.9171L45.2381 75.5999H62.6842L65.6307 55.9171L64.6808 55.2908C62.3396 53.8979 59.7195 52.9758 56.9907 52.5715C56.0053 52.4255 55.0057 52.3471 53.9999 52.3384C50.2396 52.4073 46.5746 53.442 43.4159 55.3266ZM62.3804 57.4283C59.8491 56.091 56.9695 55.3614 54.0143 55.3294C51.0444 55.3902 48.1573 56.148 45.624 57.5118L47.8245 72.6091H60.1078L62.3804 57.4283Z",
    fill: "#00B956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefaultBig);
export default __webpack_public_path__ + "static/media/avatar-default-big.6f2182ee9b0357df612a1398614b6c4f.svg";
export { ForwardRef as ReactComponent };